// profile-menu uses
// custom in-case-sensitive filter only on label
export function inCaseSensitiveSearch(label: string, searchText: string) {
  return label.toLowerCase().includes(searchText.toLowerCase())
}

// only admin-company-selector component uses
export function filterOption<Option extends { label: string }>({ label }: Option, searchText: string) {
  if (!searchText) {
    return true // no filtering
  }
  return inCaseSensitiveSearch(label, searchText)
}
